'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translateEvents = exports.createReduxMiddleware = exports.initialize = undefined;

var _utils = require('./utils');

/**
 * The tracker is a singleton object with three methods
 * initialize, createReduxMiddleware and translateEvents
 */

// method to do the actual tracking
var track = void 0;

/**
 * Method to initialize the tracker
 * @param {function} trackMethod - Reference to third party
 * method that will do the tracking
 */
var initialize = exports.initialize = function initialize() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      trackMethod = _ref.trackMethod;

  track = trackMethod;
};

/**
 * Method to generate redux middleware to track specific actions
 *
 * @param mapping - See README
 * @return {function(*=): function(*): function(*=)} redux middleware
 */
var createReduxMiddleware = exports.createReduxMiddleware = function createReduxMiddleware(mapping) {
  if (!track) {
    throw new Error('Tracker not initialized yet');
  }

  return function (store) {
    return function (next) {
      return function (action) {
        var eventCreator = mapping[action.type];

        if (eventCreator) {
          var trackingData = eventCreator(store.getState(), action.payload);
          // only track if eventCreator returns something useful
          if (trackingData) {
            var eventName = trackingData.eventName,
                eventPayload = trackingData.eventPayload;

            track(eventName, eventPayload);
          }
        }

        return next(action);
      };
    };
  };
};

/**
 * Method to translate event for non-redux actions like
 * jQuery or Ampersand events
 *
 * @param emitter - An event emitter object
 * @param mapping - See README
 * @return {function()} - function to remove listeners
 */
var translateEvents = exports.translateEvents = function translateEvents(emitter, mapping) {
  if (!track) {
    throw new Error('Tracker not initialized yet');
  }

  if (!(0, _utils.isEmitter)(emitter)) {
    throw new Error('Not an event emitter');
  }

  var eventHandlers = [];

  Object.keys(mapping).forEach(function (event) {
    var eventCreator = mapping[event];
    var handler = function handler(payload) {
      var _eventCreator = eventCreator(payload),
          eventName = _eventCreator.eventName,
          eventPayload = _eventCreator.eventPayload;

      track(eventName, eventPayload);
    };
    eventHandlers.push({ event: event, handler: handler });
    emitter.on(event, handler);
  });

  return function () {
    eventHandlers.forEach(function (_ref2) {
      var event = _ref2.event,
          handler = _ref2.handler;
      return emitter.off(event, handler);
    });
  };
};